<template>
  <div>
    <slot />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import useMatchMedia from '../../hooks/useMatchMedia';

const isMobile = useMatchMedia('(max-width: 991px)');
const props = defineProps({
  locationKey: {
    type: String,
    required: true,
  },
  click: {
    type: Function,
    default: () => {},
  },
});
</script>
